import { useEffect, useState } from 'react';
import { collection, onSnapshot, query, where } from 'firebase/firestore';
import { db } from './firebase';
import {
  isRentalCancelled,
  isRentalPaid,
  isRentalPayable,
  isRentalPaymentScheduled,
} from './rentalPayments';

export function isPaymentDueRental(rental) {
  return (
    rental?.status === 'approved' &&
    !isRentalPaid(rental) &&
    !isRentalPaymentScheduled(rental) &&
    !isRentalCancelled(rental) &&
    isRentalPayable(rental)
  );
}

export function usePaymentDueCount(user) {
  const [paymentDueCount, setPaymentDueCount] = useState(0);
  const [paymentDueRentalIds, setPaymentDueRentalIds] = useState(() => new Set());

  useEffect(() => {
    if (!user?.uid) {
      setPaymentDueCount(0);
      setPaymentDueRentalIds(new Set());
      return undefined;
    }

    const rentalsQuery = query(
      collection(db, 'rentals'),
      where('renterId', '==', user.uid)
    );

    const unsubscribe = onSnapshot(rentalsQuery, (snapshot) => {
      const dueRentals = snapshot.docs
        .map((docSnap) => ({ id: docSnap.id, ...docSnap.data() }))
        .filter(isPaymentDueRental);

      setPaymentDueCount(dueRentals.length);
      setPaymentDueRentalIds(new Set(dueRentals.map((rental) => rental.id)));
    }, (error) => {
      console.error('Payment due listener error:', error);
      setPaymentDueCount(0);
      setPaymentDueRentalIds(new Set());
    });

    return () => unsubscribe();
  }, [user?.uid]);

  return { paymentDueCount, paymentDueRentalIds };
}